import apiClient from '../services/apiClient';
import store from './store'
import theme from '../assets/utils/theme';

export default {
	namespaced: true,
	state: {
		access_token: '',
		initUserRequested: false,
		user: null,
		password_correct: false,
	},
	getters: {
		user(state) {
			return state.user
		},
		password_correct(state) {
			return state.password_correct
		}
	},
	mutations: {
		ACCESS_TOKEN(state, accessToken) {
			state.access_token = accessToken
		},
		SET_INIT_USER(state, requested) {
			state.initUserRequested = requested
		},
		SET_USER(state, user) {
			state.user = user;

			if (user === null) {
				state.initUserRequested = false;
			}
		},
		SET_PASSWORD_CHECK(state, boolean) {
			state.password_correct = boolean
		},
		CLEAR_STORE(state) {
			state.access_token = '';
			state.initUserRequested = false;
			state.user = null;
			state.password_correct = false;
		}
	},
	actions: {
		async changeUserData({commit}, userData) {
			await apiClient.put('user/update', userData).then(res => {
				commit('SET_USER', res.data);
			}).catch(err => {

			})
		},
		async checkUserPassword({commit}, passwordData) {
			await apiClient.put('user/password/check', passwordData).then(res => {
				commit('SET_PASSWORD_CHECK', res.data)
			}).catch(err => {

			})
		},
		async changeUserPassword({commit}, newpasswordData) {
			await apiClient.put('user/password/update', newpasswordData).then(res => {
			}).catch(err => {
			})
		},
		resetUserPassword({commit}, data) {
			return new Promise((resolve, reject) => {
				apiClient.put('user/password/reset', data).then(res => {
					resolve()
				}).catch(err => {
					reject()
				})
			})
		},
		sendPasswordForgetMail({commit}, email) {
			const params = {
				email
			};
			return new Promise((resolve, reject) => {
				apiClient.post('/user/password/reset/email', params).then(res => {
					resolve();
				}).catch(err => {
					reject();
				});
			});
		},
		attemptGetUser({state, commit}) {
			return new Promise((resolve, reject) => {
				if (state.initUserRequested) {
					resolve();
				}

				commit('SET_INIT_USER', true);

				if (!state.user) {
					apiClient.get('user/get').then(res => {
						commit('SET_USER', res.data);
						store.dispatch('dashboard/init');

						store.dispatch('openOrdersStore/init');

						resolve();
					}).catch(error => {
						commit('SET_USER', null);
						reject(error);
					});
				}
			})
		},
		logOutUser({commit}) {
			commit('SET_USER', null);
		},
		async createUser({commit}, userData) {
			if (userData.discount_code === '') {
				delete userData.discount_code;
			}

			await apiClient.post('auth/register', userData).then(res => {
			}).catch(err => {

			})
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
